export const isCustomHTMLEnabled = true;
export const isCommunityManagerEnabled = true;
export const isDiscordEnabled = true;
export const isWhatsAppEnabled = false;
export const areCustomIconsEnabled = false;
export const isReportingEnabled = true;
